<template>
  <span class="dimension-selector">
    <c-selector
      v-if="ready"
      :store="dimensionList"
      :width="width"
      :keyField="keyField"
      children-field="children"
      iconField="icon"
      placeholder="选择属性"
      label-field="label"
      v-model="dimension"
      :disableOptions="disableOptions"
      :showGroupShortcut="showGroupShortcut"
      :styleType="styleType"
      filterOption
    >
      <slot v-if="realTimeAble && dimension">
        <span class="c-select-label">
          {{ dimension.label
          }}<span class="prop-symbol" v-if="!dimension.realTime">{{
            propSymbol
          }}</span>
        </span>
        <i class="c-select-arrow cicon-down"></i>
      </slot>
      <div
        v-if="realTimeAble && haveUserProp"
        slot="optionsHeader"
        class="options-header-symbol"
      >
        {{ optionsHeaderTip }}
      </div>
      <template slot-scope="scope">
        <i :class="['c-icon', scope.data.icon]"></i>
        <span :title="scope.data.label">{{
          strMiddleSplit(scope.data.label)
        }}</span>
        <span v-if="realTimeAble && !scope.data.realTime" class="symbol">{{
          propSymbol
        }}</span>
      </template>
    </c-selector>
  </span>
</template>

<script>
import { mapState } from "vuex";
import { getters, actions } from "../../store/constants";
import { util } from "../../utils";
export default {
  name: "dimensionSelector",
  props: {
    value: null,
    /**
     * @description 如果是事件属性，则传事件id,多个用逗号隔开
     */
    eventIds: {
      type: String,
      default: () => {
        return "";
      }
    },
    keyField: {
      type: String,
      default: () => {
        return "value";
      }
    },
    /**
     * @description 用户属性
     */
    haveUserProp: {
      type: Boolean,
      default: false
    },
    /**
     * @description 事件环境
     */
    haveEventEnv: {
      type: Boolean,
      default: true
    },
    /**
     * @description 启用实时
     */
    realTimeAble: {
      type: Boolean,
      default: false
    },
    propSymbol: {
      type: String,
      default() {
        return "*";
      }
    },
    optionsHeaderTip: {
      type: String,
      default() {
        return "带＊的属性每日凌晨更新";
      }
    },
    /**
     * @description 禁用的选项列表：key值列表
     * @default []
     */
    disableOptions: {
      type: Array,
      default() {
        return [];
      }
    },
    width: {
      type: Number,
      default: 160
    },
    /**
     * 展示分组标题切换标签，快捷展示数据
     */
    showGroupShortcut: {
      type: Boolean,
      default: false
    },
    /**
     * 样式 类型
     */
    styleType: {
      type: String,
      default: ""
    },
    /**
     * 展示事件共有属性
     */
    showPublicAttr: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let data = {
      dimension: this.value,
      eventPropsMap: {}, // 存储事件属性数据
      dimensionList: [], // 从计算属性改为数据属性

    };
    return data;
  },
  computed: {
    ...mapState({
      // dimensionList(state) {
      //   let result = [];
      //   if (this.eventIdList.length) {
      //     // 事件及环境属性
      //     let eventPublicAttrMap = {};
      //     let eventPublicAttrList = [];
      //     this.eventIdList.forEach((id, index) => {
      //       let _eventIdMap = sessionStorage.getItem("eventIdMapTemp")
      //           ? JSON.parse(sessionStorage.getItem("eventIdMapTemp"))
      //           : state.bizSys.eventIdMap;
      //       let _eventAttrMap = sessionStorage.getItem("eventAttrMapTemp")
      //           ? JSON.parse(sessionStorage.getItem("eventAttrMapTemp"))
      //           : window.eventAttrMap;
      //       let event = _eventIdMap[id];
      //       if (event) {
      //         let eventProp = [];
      //         eventProp = _eventAttrMap[event.event_id].filter(prop => {
      //           return !prop.hidden;
      //         });
      //         eventProp.forEach(item => {
      //           const name = item.alias_name || item.attr_name;
      //           if (eventPublicAttrMap[name]) {
      //             let itemData = eventPublicAttrMap[name];
      //             itemData.times = itemData.times + 1;
      //             itemData.dimensionId += `,${item.attr_id}`;
      //           } else {
      //             eventPublicAttrMap[name] = {
      //               ...item,
      //               eventIndex: index,
      //               event_name: event.event_name,
      //               event_id: event.event_id,
      //               times: 1
      //             };
      //           }
      //         });
      //         for (let key in eventPublicAttrMap) {
      //           if (eventPublicAttrMap[key].times > 1) {
      //             delete eventPublicAttrMap[key].times;
      //             eventPublicAttrMap[key].public_attr = true;
      //             eventPublicAttrList.push(eventPublicAttrMap[key]);
      //           }
      //         }
      //         result.push({
      //           id: 0,
      //           label:
      //             this.eventIdList.length > 1
      //               ? `事件[${event.alias_name || event.event_name}]属性`
      //               : "事件属性",
      //           children: eventProp.map(item => {
      //             return {
      //               ...item,
      //               eventIndex: index,
      //               event_name: event.event_name,
      //               event_id: event.event_id
      //             };
      //           })
      //         });
      //       }
      //     });
      //     // 展示 事件共有属性
      //     if (eventPublicAttrList.length > 0 && this.showPublicAttr) {
      //       result.unshift({
      //         id: 0,
      //         label: "事件共有属性",
      //         children: eventPublicAttrList
      //       });
      //     }
      //   }
      //   if (this.haveEventEnv) {
      //     let env = sessionStorage.getItem("eventEnvsTemp") ? JSON.parse(sessionStorage.getItem("eventEnvsTemp"))  : state.bizSys.eventEnvs
      //     result.push({
      //       id: 1,
      //       label: "触发环境",
      //       children: env
      //     });
      //   }
      //   if (this.haveUserProp) {
      //     // 用户属性
      //     let userProp = [];
      //     userProp = this.$store.getters[getters.sys.getUserDimensionProps];
      //     userProp = userProp.filter(prop => {
      //       return !prop.hidden;
      //     });
      //     result.push({
      //       id: 0,
      //       label: `${
      //         state.app.currentApp.type === "user" ? "用户" : "主体"
      //       }属性`,
      //       children: userProp
      //     });
      //   }
      //   return result;
      // },
      ready(state) {
        let readys = state.bizSys.ready;
        let ready = true;
        if (
          (this.haveEventEnv && !readys.eventEnvs) ||
          (this.haveUserProp && !readys.userProps) ||
          (this.eventIdList && !readys.eventGroups)
        ) {
          ready = false;
        }
        return ready;
      }
    }),
    eventIdList() {
      if (!this.eventIds) {
        return [];
      } else {
        return this.eventIds.split(",").map(item => {
          return item ? parseInt(item) : item;
        });
      }
    }
  },
  watch: {
    eventIds: {
      handler() {
        if (this.eventIdList.length) {
          this.loadEventAttrs();
        } else {
          this.dimensionList = [];
        }
      },
      immediate: true
    },

    value(val) {
      this.initData();
    },
    // ready(ready) {
    //   this.initData();
    // },
    ready: {
      handler(newReady) {
        if (newReady) {
            this.$nextTick(() => {
              this.buildDimensionList();
            });
        }
        this.initData(); 
      },
      immediate: true
    },
    dimension() {
      if (this.value && this.value.dimensionId) {
        let dimensionId = this.value.dimensionId.split(",");
        if (
          this.keyField == "dimensionId" &&
          dimensionId[0] === "event_attr" &&
          !dimensionId[2]
        ) {
          this.dimensionIdUpdata();
        }
      }
      this.$emit("input", this.dimension);
    },
    //  // 添加对dimensionList的深度监听，强制更新c-selector
    // dimensionList: {
    //   handler(newList) {
    //     if (newList && newList.length > 0) {
    //       // 强制c-selector重新渲染
    //       this.$nextTick(() => {
    //         this.selectorKey++;
    //       });
    //     }
    //   },
    //   deep: true
    // }
  },
  beforeMount() {
    let queryParam = {
      appId: this.appId,
      platform: this.platform
    };
    if (this.haveEventEnv) {
      // 加载事件触发环境数据
      this.$store
        .dispatch(actions.biz.sys.queryEnvMeta, queryParam)
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
    if (this.haveUserProp) {
      // 加载用户属性数据
      this.$store
        .dispatch(actions.biz.sys.queryUserProps, queryParam)
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
    if (this.eventIdList) {
      // 加载事件列表数据
      this.$store
        .dispatch(actions.biz.sys.queryEventMeta, queryParam)
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
  },
  methods: {
    // 构建dimensionList的专用方法
    buildDimensionList() {
      if (!this.ready) return;
      
      let result = [];

        // 添加用户属性
      if (this.haveUserProp) {
        let userProp = this.$store.getters[getters.sys.getUserDimensionProps];
        userProp = userProp.filter(prop => !prop.hidden);
        result.push({
          id: 0,
          label: `${true ? "用户" : "主体"}属性`,
          children: userProp
        });
      }
      
      // 事件属性
      if (this.eventIdList.length) {
        // 事件及环境属性
        let eventPublicAttrMap = {};
        let eventPublicAttrList = [];
        
        this.eventIdList.forEach((id, index) => {
          let _eventIdMap = sessionStorage.getItem("eventIdMapTemp")
              ? JSON.parse(sessionStorage.getItem("eventIdMapTemp"))
              : this.$store.state.bizSys.eventIdMap;
          let event = _eventIdMap[id];
          
          if (event) {
            let eventProp = this.eventPropsMap[event.event_id] || [];
            // 处理共有属性
            eventProp.forEach(item => {
              const name = item.label ||  item.alias_name || item.attr_name ;
              if (eventPublicAttrMap[name]) {
                let itemData = eventPublicAttrMap[name];
                itemData.times = itemData.times + 1;
                itemData.dimensionId += `,${item.attr_id}`;
              } else {
                eventPublicAttrMap[name] = {
                  ...item,
                  eventIndex: index,
                  event_name: event.event_name,
                  event_id: event.event_id,
                  times: 1
                };
              }
            });
            
            // 收集共有属性
            for (let key in eventPublicAttrMap) {
              if (eventPublicAttrMap[key].times > 1) {
                delete eventPublicAttrMap[key].times;
                eventPublicAttrMap[key].public_attr = true;
                eventPublicAttrList.push(eventPublicAttrMap[key]);
              }
            }
            
            // 添加事件属性组
            result.push({
              id: 0,
              label:
                this.eventIdList.length > 1
                  ? `事件[${event.alias_name || event.event_name}]属性`
                  : "事件属性",
              children: eventProp.map(item => {
                return {
                  ...item,
                  eventIndex: index,
                  event_name: event.event_name,
                  event_id: event.event_id
                };
              })
            });
          }
        });
        // 展示事件共有属性
        if (eventPublicAttrList.length > 0 && this.showPublicAttr) {
          result.unshift({
            id: 0,
            label: "事件共有属性",
            children: eventPublicAttrList
          });
        }
      }
      
       // 添加触发环境
      if (this.haveEventEnv) {
        let env = sessionStorage.getItem("eventEnvsTemp") 
          ? JSON.parse(sessionStorage.getItem("eventEnvsTemp"))  
          : this.$store.state.bizSys.eventEnvs;
        result.push({
          id: 1,
          label: "触发环境",
          children: env
        });
      }

      this.dimensionList = result;

    },
    async loadEventAttrs() {
      try {
        for (let id of this.eventIdList) {
          let eventId = id;
          let attrs = await this.queryEventAttrs(eventId);
          // 确保attrs是数组格式
          this.$set(this.eventPropsMap, eventId, Array.isArray(attrs) ? attrs : []);
        }
      } catch (error) {
        console.error('加载事件属性失败:', error);
      } finally {
        this.buildDimensionList();
      }
    },
    queryEventAttrs(eventId){
      return this.$store
        .dispatch(actions.biz.sys.queryEventAttrs, {
          eventId
        })
        .then(attrs => {
          // 应用数据转化逻辑
          const formattedAttrs = attrs.map(item => ({
            alias: item.alias_name,
            eventId: eventId,
            id: item.attr_id,
            isHidden: item.hidden,
            key: `eventProp-${item.attr_id}`,
            label: item.attr_name,
            propCategory: 'eventProp',
            type: item.prop_type,
            dimension_sub: item.dimension_sub || 'eventProp',
            isEventProp: true,
            custom: true,
            realTime: true,
            value: item.attr_id, // 添加value属性，确保c-selector能正确识别选中项
            dimensionId: `${item.dimension_sub},${item.attr_id},${item.attr_id}` // 添加dimensionId属性，与keyField匹配
          }));

          return formattedAttrs;
        })
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        })
    },
    strMiddleSplit(str) {
      if (util.isString(str)) {
        return util.strMiddleSplit(str, {
          maxLength: 50,
          beginLength: 47,
          endLength: 0,
          replaceStr: "..."
        });
      }
      return str;
    },
    dimensionIdUpdata() {
      let dimensionId = this.value.dimensionId.split(",");
      let value = { ...this.value };
      let eventProp = [];
      this.dimensionList.forEach(prop => {
        if (prop.label.includes("事件")) {
          eventProp.push(...prop.children);
        }
      });
      let flag = true;
      eventProp.forEach(item => {
        if (
          item.dimension_sub == dimensionId[0] &&
          item.value == dimensionId[1] &&
          flag
        ) {
          dimensionId[2] = item.attr_id;
          flag = false;
        }
      });
      value.dimensionId = dimensionId.join(",");
      this.dimension = value;
    },
    initData() {
      if (this.value) {
        let dimensionIdStr = [];
        if (this.value.dimensionId)
          dimensionIdStr = this.value.dimensionId.split(",");
        if (
          this.keyField == "dimensionId" &&
          dimensionIdStr[0] === "event_attr" &&
          !dimensionIdStr[2]
        ) {
          this.dimensionIdUpdata();
        } else {
          this.dimension = this.value;
        }
      } else {
        this.dimension = null;
      }
    }
  }
};
</script>

<style lang="sass">
@import "styles/index"
</style>
